import { SelectionChange, SelectionModel } from '@angular/cdk/collections';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { PageEvent, RdsDialogService, RdsPaginatorComponent, RdsSortDirective, Sort, SortDirection } from '@rds/angular-components';
import { distinctUntilChanged, filter, Observable } from 'rxjs';
import { SubSink } from 'subsink';
import * as fromDetails from '../../../../store/channel-details';
import * as fromRouter from '@app/root-store/router';
// import * as fromForm from '../../store/form';

import { Channel, ChannelDetails, News } from '@app/types';
import { Pagination } from '@app/types/pagination';
import { AuthService, SimpleUser } from '@app/auth/auth.service';
import { Confirm2DialogComponent, ConfirmDialogData } from '@app/utils/confirm2-dialog/confirm-dialog.component';
import { NewsTableFilters } from '@app/news/store/news-table';
import { getRemoveNewsFromArchivedDialog } from '@app/utils/confirm2-dialog/confirm-dialog.models';

@Component({
  selector: 'rnb-archived-news-table',
  templateUrl: './archived-news-table.container.html',
  styleUrls: ['./archived-news-table.container.scss']
})
export class ArchivedNewsTableContainer implements OnInit, OnDestroy {
  subs: SubSink = new SubSink();

    get identifier(): string {
    return this.auth.currentUser.identifier;
  }

  get isAdmin(): boolean {
    return this.auth.currentUser.isAdmin;
  }

  columns: Array<string> = ['title', 'owners', 'type', 'created', 'published', 'archived', 'actions'];

  get isSuperAdmin(): boolean {
    return this.auth.currentUser.isSuperAdmin;
  }
  
  channelDetails$: Observable<ChannelDetails> = this.store$.pipe(select(fromDetails.selectChannelDetails));

  news: Array<Partial<News>> = []; 
  news$: Observable<Array<Partial<News>>> = this.store$.pipe(select(fromDetails.selectArchivedNewsData));
  
  pagination$: Observable<Pagination> = this.store$.pipe(select(fromDetails.selectArchivedNewsPagination));
  total$: Observable<number> = this.store$.pipe(select(fromDetails.selectArchivedNewsTotal));

  isLoading$: Observable<boolean> = this.store$.pipe(select(fromDetails.selectArchivedNewsIsLoading));

  defaultSort$: Observable<{ active: string, direction: SortDirection}> = this.store$.pipe(select(fromDetails.selectArchivedNewsDefaultSort));

  filters$: Observable<NewsTableFilters> = this.store$.pipe(select(fromDetails.selectArchivedNewsFilters));
  defaultFilters$: Observable<NewsTableFilters> = this.store$.pipe(select(fromDetails.selectArchivedNewsDefaultFilters));
  search$: Observable<string> = this.store$.pipe(select(fromDetails.selectArchivedNewsSearch));

  constructor(
    private store$: Store<fromDetails.State>,
    private dialogService: RdsDialogService,
    private auth: AuthService,
  ) { }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {

  }

  canEditNews(news: News) {
    return this.isAdmin || this.isSuperAdmin || !!news.owners.find(u => u.identifier === this.identifier) || !!news.editors.find(u => u.identifier === this.identifier)
  }
  
  filtersChanged(filters: NewsTableFilters) {
    this.store$.dispatch(fromDetails.changeArchivedNewsFilters({filters}));
  }

  sortChanged(event: Sort) {
      this.store$.dispatch(fromDetails.changeArchivedNewsSort({active: event.active, direction: event.direction}));
  }

  paginationChanged(event: PageEvent) {
    this.store$.dispatch(fromDetails.changeArchivedNewsPagination({pageIndex: event.pageIndex, pageSize: event.pageSize}));
  }

  selectionChanged(event: SelectionChange<News>) {
  }
    
  removeNews(selection: SelectionModel<News>) {
    const ids = selection.selected.map(n => n.id);
    const data: ConfirmDialogData = getRemoveNewsFromArchivedDialog(ids);
    const dialog = this.dialogService.open(Confirm2DialogComponent, {
      data
    });

    dialog.afterClosed().pipe(
      filter(data => !!data)
    ).subscribe(data => this.store$.dispatch(fromDetails.removeArchivedNewsRequest({ids: data.ids})));
  }

  removeSingleNews(id: string, newsTitle) {
    const ids = [+id];
    const data: ConfirmDialogData = getRemoveNewsFromArchivedDialog(ids, newsTitle);

    const dialog = this.dialogService.open(Confirm2DialogComponent, {
      data
    });
    
    dialog.afterClosed().pipe(
      filter(data => !!data)
    ).subscribe(data => this.store$.dispatch(fromDetails.removeArchivedNewsRequest({ids: data.ids})));
  }

  onLinkClick({link, linkType}: {link: string, linkType: 'route' | 'url'}, channelName, channelId) {
    this.openNewsPreview(+link, channelName, channelId);
  }

  openNewsPreview(newsId: number, channelName, channelId) {
    this.store$.dispatch(fromDetails.openNewsPreview({newsId, backButton: {
      label: `Channel: ${channelName}`,
      routeBack: `channel/${channelId}/all`,
      routeCurrent: `/news/${newsId}/edit`
    }}))
  }

  duplicate(id) {
    this.store$.dispatch(fromDetails.duplicateNewsRequest({newsId: id }));
  }
}
